<template>
    <div>
        <!-- Info Banner -->
        <div class="form-info-banner">
            <h3 class="form-info-banner-title">Os campos com * são de preenchimento obrigatório</h3>
            <p class="form-info-banner-text">Caso queira, você poderá salvar e continuar depois.</p>
        </div>
        
        <div class="space-y-8">
            <!-- Seção: Declarações de Vínculo -->
            <section class="form-section">
                <div class="form-section-header">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Declarações de Vínculo do Cliente'"
                        :Sessao="'Declarações'" :SubSessao="'Vinculo cliente'" />
                </div>
                <div class="form-section-content">
                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Você trabalha ou possui vínculo com a {{ nomeEmpresa }}?</label>
                            <div class="form-radio-group">
                                <label class="form-radio-item">
                                    <input type="radio" value="false" name="VinculoRJI" class="form-radio-input"
                                        v-model="localPF.VinculoRJI" @change="salvarAlteracoesLocalmente" />
                                    <span class="form-radio-label">Não</span>
                                </label>
                                <label class="form-radio-item">
                                    <input type="radio" value="true" name="VinculoRJI" class="form-radio-input"
                                        v-model="localPF.VinculoRJI" @change="salvarAlteracoesLocalmente" />
                                    <span class="form-radio-label">Sim</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <!-- Seção: PEP -->
            <section class="form-section">
                <div class="form-section-header">
                    <h5 class="text-lg font-semibold text-gray-900 dark:text-gray-100">PEP - Pessoa Exposta Politicamente</h5>
                </div>
                <div class="form-section-content">
                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Você ou alguém de seu relacionamento exerce ou exerceu algum cargo público nos últimos 5 anos?</label>
                            <div class="form-radio-group">
                                <label class="form-radio-item">
                                    <input type="radio" value="false" name="expostaPoliticamente"
                                        class="form-radio-input" v-model="localPF.ConhecePep"
                                        @change="salvarAlteracoesLocalmente" />
                                    <span class="form-radio-label">Não</span>
                                </label>
                                <label class="form-radio-item">
                                    <input type="radio" value="true" name="expostaPoliticamente"
                                        class="form-radio-input" v-model="localPF.ConhecePep"
                                        @change="salvarAlteracoesLocalmente" />
                                    <span class="form-radio-label">Sim</span>
                                </label>
                            </div>
                            <div class="flex items-center gap-2 mt-2">
                                <svg @click="abrirPepInformativo" class="w-5 h-5 cursor-pointer text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-blue-400 transition-colors" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
                                </svg>
                                <label @click="abrirPepInformativo" class="form-link cursor-pointer">O que é PEP?</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label" for="especificacaoPep">Se sim, especifique</label>
                            <textarea @change="salvarAlteracoesLocalmente" v-model="localPF.EspecificacaoPep"
                                id="especificacaoPep" class="field" rows="3"></textarea>
                        </div>
                    </div>
                </div>
            </section>
            
            <!-- Seção: FATCA -->
            <section class="form-section">
                <div class="form-section-header">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'FATCA (Foreign Account Tax Compliance Act)'"
                        :Sessao="'Declarações'" :SubSessao="'FACTA'" />
                </div>
                <div class="form-section-content">
                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Você é um cidadão americano ou possui Green Card?</label>
                            <div class="form-radio-group">
                                <label class="form-radio-item">
                                    <input type="radio" value="false" name="CidadaoAmericado" class="form-radio-input"
                                        v-model="localPF.CidadaoAmericado" @change="salvarAlteracoesLocalmente" />
                                    <span class="form-radio-label">Não</span>
                                </label>
                                <label class="form-radio-item">
                                    <input type="radio" value="true" name="CidadaoAmericado" class="form-radio-input"
                                        v-model="localPF.CidadaoAmericado" @change="salvarAlteracoesLocalmente" />
                                    <span class="form-radio-label">Sim</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <!-- Seção: Declarações -->
            <section class="form-section">
                <div class="form-section-header">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Declarações'"
                        :Sessao="'Declarações'" :SubSessao="'Declarações'" />
                </div>
                <div class="form-section-content">
                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Declaro que opero por conta:</label>
                            <div class="form-radio-group">
                                <label class="form-radio-item">
                                    <input type="radio" value="true" name="OperaPorConta" class="form-radio-input"
                                        v-model="localPF.OperaPorConta" @change="salvarAlteracoesLocalmente" />
                                    <span class="form-radio-label">Própria</span>
                                </label>
                                <label class="form-radio-item">
                                    <input type="radio" value="false" name="OperaPorConta" class="form-radio-input"
                                        v-model="localPF.OperaPorConta" @change="salvarAlteracoesLocalmente" />
                                    <span class="form-radio-label">de Terceiros</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <DeclaracoesDocumentos />
                </div>
            </section>
        </div>
    </div>
    <ModalInformativoPep />
</template>

<script>
import LabelDisclaimer from '@/components/LabelDisclaimer.vue'
import { mapGetters } from 'vuex';
import ModalInformativoPep from '../PEP/ModalInformativoPep.vue'
import DeclaracoesDocumentos from './DeclaracoesDocumentos.vue';
import { TIPO_CLIENTE } from '@/constants/TipoClienteEnum';

export default {
    name: 'CadastroPF_Declaracoes',
    props: ['informacoesDeclaracoes', 'Edicao'],
    components: { ModalInformativoPep, DeclaracoesDocumentos, LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            listaDocumentos: 'GET_LISTA_DOCUMENTOS',
            listaDocumentosCliente: 'GET_LISTA_DOCUMENTOS_CLIENTE'
        }),
    },
    mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    },
    data() {
        return {
            permitirAvancar: false,
            localPF: this.informacoesDeclaracoes,
            nomeEmpresa: ''
        }
    },
    watch: {
        listaDocumentosCliente() {
            this.validarFormulario();
        }
    },
    methods: {
        abrirPepInformativo() {
            this.$store.commit('SET_MODAL_PEP_INFORMATIVO', true);
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            if (this.listaDocumentos != null && this.listaDocumentos.length > 0) {
                this.listaDocumentos.forEach(documentoObj => {
                    if (documentoObj.TipoCliente == TIPO_CLIENTE.PESSOA_FISICA && documentoObj.Obrigatoriedade == 'Sim') {

                        if(!this.listaDocumentosCliente){
                            this.permitirAvancar = false;
                            nomeDoCampo = documentoObj.NomeDocumento;
                        }else if (!this.listaDocumentosCliente.some(p => p.TemplateId === documentoObj.TemplateId) ||
                                this.listaDocumentosCliente.some(p => p.TemplateId === documentoObj.TemplateId && p.Status == 'Pendente')) {
                                this.permitirAvancar = false;
                                nomeDoCampo = documentoObj.NomeDocumento;
                        }
                    }
                });
            }
            else
            {
                this.permitirAvancar = false;
            }
            
            if (submeter && nomeDoCampo != '') {
                this.$alert({
                    icon: 'warning',
                    title: 'Atenção: documento não assinado',
                    text: `O documento ` + nomeDoCampo + ` é obrigatório e não foi assinado, aceite os termos para avançar`,
                });
            }

            return this.permitirAvancar;
        },
        proximaEtapa() {
            if (this.validarFormulario(true)) {
                this.$store.commit('SET_ETAPA_CADASTRO', 7);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_PF_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PF_SALVAR_INFO_DECLARACOES', this.localPF);
        },
    }
}

</script>

<style scoped>
/* Styles handled by Tailwind utility classes and global form components */
</style>